// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DMzL","left":"styles_left__2QWw-","navigationLink":"styles_navigationLink__1D9yf"};